import React, { useMemo } from 'react'
import { Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const ClientArea: React.FC = () => {
  const { user, isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const selectedPlanId = (location.state as any)?.selectedPlanId as string | undefined
  const isAdmin = useMemo(() => {
    const roles = user?.roles ?? []
    return roles.some((r) => ['admin', 'administrator'].includes(String(r).toLowerCase()))
  }, [user?.roles])

  if (!isAuthenticated) {
    return (
      <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 } }}>
        <Card>
          <CardContent sx={{ p: 3 }}>
            <Stack spacing={1.5}>
              <Typography variant="h4" sx={{ fontWeight: 900 }}>
                Área do Cliente
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                Faça login para continuar.
              </Typography>
              <Box>
                <Button variant="contained" color="info" onClick={() => navigate('/?login=1')}>
                  Entrar
                </Button>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    )
  }

  if (isAdmin) {
    return <Navigate to="/admin" replace state={{ selectedPlanId }} />
  }

  return <Navigate to="/dashboard" replace state={{ selectedPlanId }} />

}

export default ClientArea
